/*
 *
 * MyEGiftCards reducer
 *
 */

import { fromJS } from 'immutable';
import { MY_E_GIFT_CONSTANTS } from './constants';

const { DEFAULT_ACTION, FETCH_GIFTCARD_SUCCESS, SET_GIFTCARD_ACTIVATE_SUCCESS, SET_OTP_GIFTCARD_SUCCESS } = MY_E_GIFT_CONSTANTS;
const initialState = fromJS({ eVoucherDetails: { evouchers: [], totalRecords: 0 }, isLoading: false, eVoucherActivate: {}, otpSuccess: [] });

function myEGiftCardsReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case FETCH_GIFTCARD_SUCCESS:
      return state
        .set('eVoucherDetails', fromJS(payload))
        .set('isLoading', false);
    case SET_GIFTCARD_ACTIVATE_SUCCESS:
      return state
        .set('eVoucherActivate', fromJS(payload));
    case SET_OTP_GIFTCARD_SUCCESS:
      return state
        .set('otpSuccess', fromJS(payload));
    default:
      return state;
  }
}

export default myEGiftCardsReducer;



// WEBPACK FOOTER //
// client/containers/MyEGiftCards/reducer.js